(function () {
  'use strict';

  function initAerogripCockpit() {
    var config = window.AerogripCockpitConfig;
    var root = document.querySelector('[data-aerogrip-cockpit]');
    if (!config || !root) return;

    document.body.classList.add('aerogrip-cockpit-page');

    var handle = config.handle;
    var guides = config.guides || {};
    var optionPhotos = config.optionPhotos || {};
    var modal = document.getElementById('AerogripSizeGuideModal');
    var modalTitle = document.getElementById('AerogripGuideTitle');
    var modalText = document.getElementById('AerogripGuideText');
    var modalImage = document.getElementById('AerogripGuideImage');

    function getPhotoInput() {
      return document.querySelector(
        '[data-field-name="Your Position"]'
      );
    }

    function hasFitPhoto() {
      var photoInput = getPhotoInput();
      var photoUrl = getFitPhotoUrl();

      return !!(
        photoUrl ||
        (
          photoInput &&
          photoInput.files &&
          photoInput.files.length
        )
      );
    }

    function showFitPhotoWarning() {
      var photoInput = getPhotoInput();

      alert(
        'Upload a clear side-view photo of your riding position. Indoor trainer photos are perfectly fine.'
      );

      if (photoInput) {
        photoInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        /*
          Give Globo's upload field focus where possible.
        */
        try {
          photoInput.focus({
            preventScroll: true
          });
        } catch (error) {
          photoInput.focus();
        }
      }
    }

    function bindFitPhotoListener() {
      var input = getPhotoInput();
      var hidden = document.getElementById('AerogripFitPhotoName');

      if (!input) return;

      if (input.dataset.aerogripPhotoBound === 'true') return;
      input.dataset.aerogripPhotoBound = 'true';

      input.addEventListener('change', function () {
        if (
          hidden &&
          input.files &&
          input.files.length
        ) {
          hidden.value = input.files[0].name;
        }
      });
    }

    function getFitPhotoUrl() {
      var link = document.querySelector('.gpo-f-card a');
      return link ? link.href : '';
    }

    function collectOptions() {
      var grouped = {};

      function collect(input) {
        if (!input.value) return;

        var label = (input.dataset.fieldName || '').trim();
        if (!label) return;

        if (!grouped[label]) {
          grouped[label] = [];
        }

        grouped[label].push(input.value);
      }

      document
        .querySelectorAll('.gpo-container input:checked')
        .forEach(collect);

      document
        .querySelectorAll(
          '.gpo-container select,' +
          '.gpo-container textarea,' +
          '.gpo-container input[type=text]'
        )
        .forEach(collect);

      return grouped;
    }

    function buildMessage() {
      var grouped = collectOptions();
      var lines = [];

      function add(label, showLabel) {
        if (!grouped[label]) return;

        grouped[label].forEach(function (value) {
          lines.push(
            showLabel
              ? '• ' + label + ': ' + value
              : '• ' + value
          );
        });
      }

      var quoteID = 'AG-' + Date.now().toString().slice(-6);

      lines.push('AEROGRIP QUOTE REQUEST');
      lines.push('Quote ID: ' + quoteID);
      lines.push('');
      lines.push('Product: ' + config.productTitle);
      lines.push('');

      if (
        handle === 'regular-cockpit' ||
        handle === 'performance-cockpit'
      ) {
        lines.push(
          handle === 'regular-cockpit'
            ? '=== ATHLETE FIT (REGULAR COCKPIT) ==='
            : '=== ATHLETE FIT (PERFORMANCE COCKPIT) ==='
        );

        add('Cockpit Size', true);
        add('Cockpit Width', true);
        add('Hand Width', true);

        lines.push('');
      }

      if (handle === 'tailored-cockpit') {
        lines.push(
          '=== ATHLETE FIT (TAILORED MEASUREMENTS) ==='
        );

        add('Forearm Length', true);
        add('Elbow Width', true);
        add('Hand Width', true);

        lines.push('');
      }

      lines.push('=== OPTIONS ===');

      add('Shifter Type');
      add('Grip Type');
      add('Computer Mount');
      add('Bottle Mounts');
      add('Cooling');
      add('Misc');
      add('Paint');
      add('Preferred Color');

      lines.push('');

      lines.push('=== RIDER CONTEXT ===');

      add('Your Bike');

      if (grouped.Comments) {
        grouped.Comments.forEach(function (value) {
          lines.push('• Comments: ' + value);
        });
      }

      lines.push('');

      var locationField =
        document.getElementById('AerogripQuoteLocation');

      var location = locationField
        ? locationField.value
        : '';

      lines.push('=== CUSTOMER INFO ===');
      lines.push('• Location: ' + location);
      lines.push(
        '• Country Code: ' +
        location.slice(0, 2).toUpperCase()
      );

      var photo = getFitPhotoUrl();

      lines.push(
        '• Fit photo: ' + (photo || 'missing')
      );

      return lines.join('\n');
    }


    /*
      --------------------------------------------------
      ALL COCKPITS
      Validate fit photo before Request a Quote
      --------------------------------------------------
    */

    var quoteForm =
      document.getElementById('AerogripRequestQuoteForm');

    if (quoteForm) {
      quoteForm.addEventListener(
        'submit',
        function (event) {

          if (!hasFitPhoto()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            showFitPhotoWarning();

            return false;
          }

          var name =
            (
              document.getElementById('AerogripQuoteName') ||
              {}
            ).value || '';

          var country =
            (
              document.getElementById('AerogripQuoteLocation') ||
              {}
            ).value || '';

          var quoteID =
            'AG-' + Date.now().toString().slice(-6);

          var today =
            new Date().toLocaleDateString('nl-NL');

          document.getElementById(
            'AerogripQuoteSubject'
          ).value =
            'Aerogrip Quote ' +
            quoteID +
            ' – ' +
            config.productTitle +
            ' – ' +
            name +
            ' – ' +
            country +
            ' – ' +
            today;

          document.getElementById(
            'AerogripQuoteOptionsSummary'
          ).value = buildMessage();

        },
        true
      );
    }


    /*
      --------------------------------------------------
      SIZE GUIDES
      --------------------------------------------------
    */

    function injectGuide(label) {
      var field = document.querySelector(
        '[data-field-name="' + label + '"]'
      );

      if (!field) return;

      var element = field.closest('.gpo-element');
      if (!element) return;

      var labelEl =
        element.querySelector('.label-content');

      if (
        !labelEl ||
        labelEl.querySelector(
          '.aerogrip-sizeguide-trigger'
        )
      ) {
        return;
      }

      var button =
        document.createElement('span');

      button.className =
        'aerogrip-sizeguide-trigger';

      button.innerText =
        '📏 Size guide';

      button.addEventListener(
        'click',
        function () {
          openGuide(label);
        }
      );

      labelEl.appendChild(button);
    }


    /*
      --------------------------------------------------
      MODAL
      --------------------------------------------------
    */

    function openModal(item) {
      if (!item || !modal) return;

      hideHoverPreview();

      modalTitle.innerHTML =
        item.title || '';

      modalText.innerHTML =
        item.text || '';

      if (item.image) {
        modalImage.src = item.image;
        modalImage.style.display = 'block';
      } else {
        modalImage.removeAttribute('src');
        modalImage.style.display = 'none';
      }

      modal.classList.add('open');

      modal.setAttribute(
        'aria-hidden',
        'false'
      );
    }

    function closeModal() {
      if (!modal) return;

      modal.classList.remove('open');

      modal.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    function openGuide(label) {
      openModal(guides[label]);
    }

    function openOptionPhoto(optionName) {
      openModal(optionPhotos[optionName]);
    }

    var closeButton =
      root.querySelector(
        '.aerogrip-modal-close'
      );

    var overlay =
      root.querySelector(
        '.aerogrip-modal-overlay'
      );

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        closeModal
      );
    }

    if (overlay) {
      overlay.addEventListener(
        'click',
        closeModal
      );
    }

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          modal &&
          modal.classList.contains('open')
        ) {
          closeModal();
        }

      }
    );


    /*
      --------------------------------------------------
      OPTION PHOTO HOVER PREVIEW
      --------------------------------------------------
    */

    function showHoverPreview(url, x, y) {
      var preview =
        document.getElementById(
          'AerogripHoverPreview'
        );

      var image =
        document.getElementById(
          'AerogripHoverPreviewImage'
        );

      if (!preview || !image) return;

      preview.style.removeProperty(
        'display'
      );

      image.src = url;

      preview.style.left =
        (x + 18) + 'px';

      preview.style.top =
        (y + 18) + 'px';

      preview.classList.add('open');
    }

    function moveHoverPreview(x, y) {
      var preview =
        document.getElementById(
          'AerogripHoverPreview'
        );

      if (!preview) return;

      preview.style.left =
        (x + 18) + 'px';

      preview.style.top =
        (y + 18) + 'px';
    }

    function hideHoverPreview() {
      var preview =
        document.getElementById(
          'AerogripHoverPreview'
        );

      var image =
        document.getElementById(
          'AerogripHoverPreviewImage'
        );

      if (!preview || !image) return;

      preview.classList.remove('open');

      preview.style.removeProperty(
        'display'
      );

      image.removeAttribute('src');
    }


    /*
      --------------------------------------------------
      OPTION PHOTO BUTTONS
      --------------------------------------------------
    */

    function injectOptionPhotoLinks() {
      var supportsHover =
        window.matchMedia(
          '(hover: hover) and (pointer: fine)'
        ).matches;

      document
        .querySelectorAll(
          '.gpo-choicelist .choicelist-item__value'
        )
        .forEach(function (element) {

          if (
            element.querySelector(
              '.aerogrip-optionphoto-trigger'
            )
          ) {
            return;
          }

          var text =
            element.textContent.trim();

          var match =
            Object.keys(optionPhotos)
              .find(function (key) {
                return text.includes(key);
              });

          if (!match) return;

          var button =
            document.createElement('span');

          button.className =
            'aerogrip-optionphoto-trigger';

          button.innerHTML = ' 📷';

          button.addEventListener(
            'click',
            function (event) {

              event.preventDefault();
              event.stopPropagation();

              openOptionPhoto(match);

            }
          );

          if (supportsHover) {

            button.addEventListener(
              'mouseenter',
              function (event) {

                showHoverPreview(
                  optionPhotos[match].image,
                  event.clientX,
                  event.clientY
                );

              }
            );

            button.addEventListener(
              'mousemove',
              function (event) {

                moveHoverPreview(
                  event.clientX,
                  event.clientY
                );

              }
            );

            button.addEventListener(
              'mouseleave',
              hideHoverPreview
            );
          }

          element.appendChild(button);

        });
    }


    /*
      --------------------------------------------------
      GLOBO INITIALISATION
      --------------------------------------------------
    */

    function injectAerogripHelpers() {
      bindFitPhotoListener();

      if (
        handle === 'regular-cockpit' ||
        handle === 'performance-cockpit'
      ) {
        injectGuide('Cockpit Size');
        injectGuide('Cockpit Width');
        injectGuide('Hand Width');
      }

      if (handle === 'tailored-cockpit') {
        injectGuide('Forearm Length');
        injectGuide('Elbow Width');
        injectGuide('Hand Width');
      }

      injectOptionPhotoLinks();
    }


    /*
      Globo Product Options is inserted asynchronously.
      Try immediately, retry afterwards, and watch for
      later Globo renders.
    */

    injectAerogripHelpers();

    window.setTimeout(
      injectAerogripHelpers,
      500
    );

    window.setTimeout(
      injectAerogripHelpers,
      1200
    );

    window.setTimeout(
      injectAerogripHelpers,
      2500
    );

    var aerogripObserverTimer = null;

    var aerogripObserver =
      new MutationObserver(
        function (mutations) {

          var globoChanged =
            mutations.some(
              function (mutation) {

                return Array.prototype.some.call(
                  mutation.addedNodes || [],
                  function (node) {

                    if (
                      !node ||
                      node.nodeType !== 1
                    ) {
                      return false;
                    }

                    return (
                      (
                        node.matches &&
                        node.matches(
                          '.gpo-container,' +
                          ' .gpo-element,' +
                          ' .gpo-choicelist,' +
                          ' .choicelist-item__value'
                        )
                      ) ||
                      (
                        node.querySelector &&
                        node.querySelector(
                          '.gpo-container,' +
                          ' .gpo-element,' +
                          ' .gpo-choicelist,' +
                          ' .choicelist-item__value'
                        )
                      )
                    );

                  }
                );

              }
            );

          if (!globoChanged) return;

          window.clearTimeout(
            aerogripObserverTimer
          );

          aerogripObserverTimer =
            window.setTimeout(
              injectAerogripHelpers,
              50
            );

        }
      );

    aerogripObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /*
    --------------------------------------------------
    START
    --------------------------------------------------
  */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAerogripCockpit
    );

  } else {

    initAerogripCockpit();

  }

})();